import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSummitPulseTeamSpirit on SummitPulseTeamSpirit {
    description
    overallMood
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSummitPulseTeamSpiritFragment,
  ents.core.summit.Pulse.TeamSpirit
>({
  description: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  overallMood: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
})
